<template>
  <div class="footer-container">
    <div class="footer-nav">
      <router-link to="/about-us">关于我们</router-link>
      <el-divider direction="vertical"></el-divider>
        <a href="https://support.qq.com/product/421173" :underline="false" type="primary" target="_blank">联系我们</a>
      <el-divider direction="vertical"></el-divider>
      <!-- <span>加入我们</span>
      <el-divider direction="vertical"></el-divider>
      <span>免责声明</span>
      <el-divider direction="vertical"></el-divider> -->
      <router-link to="/privacy-web">隐私协议</router-link>
      <el-divider direction="vertical"></el-divider>
      <router-link to="/user-web">服务协议</router-link>
    </div>
    <div class="copyright">
      <p style="line-height:35px">
        <span>ICP主体备案号</span>
        <el-link href="http://beian.miit.gov.cn/" target="_blank" style="color:#383E45;font-size:16px;font-weight:400" :underline="false">{{icp}}</el-link>
        <span>主办单位名称</span>
        <span>上海倍明信息科技有限公司</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      icp: ''
    }
  },
  mounted() {
    this.icp = window.location.host.endsWith('img-meta.com') ? '沪ICP备2022001599号-2' : '沪ICP备2022001599号-1';
  }
}
</script>

<style lang="scss" scoped>
.footer-container {
  width: 100%;
  padding: 20px 0;
  height: 173px;
  background-color: #f6f6f6;
  color: #383E45;

  .footer-nav {
    height: 60px;
    line-height: 60px;
    
    a {
      color: #383E45;
    }

    a:hover {
      color: #409EFF;
    }

    .el-divider--vertical {
      margin: 0 20px;
    }
  }
  .copyright {
    line-height: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/components/Footer/index.vue